import { motion } from "framer-motion";
import { SectionHeading, FadeUp } from "./Reveal";

const LAYERS = [
  { name: "Applications", note: "Web · Mobile · SaaS · Portals", techs: ["Microservices", "Serverless", "APIs"] },
  { name: "Platform", note: "Containers · Orchestration · Delivery", techs: ["Docker", "Kubernetes", "CI/CD"] },
  { name: "Data", note: "Transactional · Streaming · Cache", techs: ["PostgreSQL", "Redis", "Kafka"] },
  { name: "Infrastructure", note: "Cloud-native · Observable · Secure", techs: ["AWS", "Azure", "Google Cloud", "Observability"] },
];

export const CloudEngineering = () => (
  <section data-testid="cloud-engineering-section" className="py-24 sm:py-32 bg-jx-mist relative overflow-hidden">
    <div className="pointer-events-none absolute -top-32 right-0 w-[480px] h-[480px] rounded-full bg-jx-purple/10 blur-3xl" />
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-16 items-center">
        <div className="lg:col-span-5">
          <SectionHeading
            testId="cloud-engineering"
            overline="Cloud & Engineering"
            title={<>Engineered for <span className="jx-gradient-text">reliability.</span></>}
            body="We build cloud-native systems where applications, APIs, data and infrastructure operate as one observable, resilient architecture."
          />
        </div>

        <div className="lg:col-span-7">
          <div data-testid="cloud-architecture-visual" className="relative flex flex-col gap-3">
            <div className="absolute left-1/2 top-6 bottom-6 w-px jx-gradient-bg opacity-20 -translate-x-1/2 hidden sm:block" />
            {LAYERS.map((layer, i) => (
              <FadeUp key={layer.name} delay={i * 0.12}>
                <motion.div
                  whileHover={{ scale: 1.015 }}
                  transition={{ duration: 0.3 }}
                  data-testid={`cloud-layer-${i}`}
                  className="relative rounded-2xl bg-white border border-jx-ink/8 p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
                  style={{ marginLeft: `${i * 3}%`, marginRight: `${(LAYERS.length - 1 - i) * 3}%` }}
                >
                  <div className="sm:w-44 shrink-0">
                    <p className="font-display font-bold text-lg tracking-tight text-jx-ink">{layer.name}</p>
                    <p className="text-xs text-jx-ink/45 mt-1">{layer.note}</p>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {layer.techs.map((t, j) => (
                      <motion.span
                        key={t}
                        initial={{ opacity: 0, scale: 0.85 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 + i * 0.12 + j * 0.06 }}
                        className="inline-flex items-center gap-1.5 rounded-full bg-jx-mist border border-jx-ink/6 px-3.5 py-1.5 text-xs font-semibold text-jx-ink/70"
                      >
                        <motion.span
                          animate={{ opacity: [0.4, 1, 0.4] }}
                          transition={{ duration: 2.4, repeat: Infinity, delay: j * 0.5 }}
                          className="w-1.5 h-1.5 rounded-full jx-gradient-bg"
                        />
                        {t}
                      </motion.span>
                    ))}
                  </div>
                </motion.div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
